import { createAsyncThunk } from '@reduxjs/toolkit';
import getUnloadingPointInfoUseCase from 'modules/inbound/entriesST12/application/getUnloadingPointInfoUseCase';

const getUnloadingPointInfo = createAsyncThunk(
  'entriesST12UnloadingPoint/getUnloadingPointInfo',
  async () => {
    const response = await getUnloadingPointInfoUseCase.execute();
    return response;
  }
);

export { getUnloadingPointInfo };
